<template>
    <div class="h-100 bg-cybo_right_bg text-cybo_right_text">
        <!-- BON DISPLAY -->
        <div v-if="mainState === 2" class="flex flex-row h-100">
            <!-- left -->
            <div class="flex flex-1 h-100 bg-cybo_left_bg">
                <div class="mt-10 mb-20 max-w-bon mx-auto overflow-y-auto">
                    <img :src="pathToPng" class="w-100 pt-2 bg-white rounded-tr-3xl" alt="" />
                </div>
            </div>

            <!-- right -->
            <div class="flex flex-1 h-100 bg-cybo_right_bg text-cybo_right_text">
                <div
                    v-if="deletionState === 0"
                    class="
                        flex flex-col
                        bg-cybo_button_container_bg
                        h-desktop_button_container
                        w-desktop_button_container
                        mt-10p
                        mx-auto
                        pt-4
                        border-2
                        rounded-t-3xl rounded-bl-3xl
                        border-cybo_button_container_border
                    "
                >
                    <img :src="this.$icons.cyboLogoCybo" class="mx-auto w-28" alt="cybo-logo" />
                    <div class="py-2">Wie möchten Sie Ihren Kassenzettel<br />speichern?</div>

                    <button
                        class="button-filled mx-auto flex flex-row px-3 h-10 mt-2"
                        @click="triggerDownloadImage"
                    >
                        <div class="flex-1"></div>
                        <div class="flex flex-col h-full">
                            <div class="flex-1"></div>
                            <div class="flex flex-row">
                                <!--
                                <div>
                                    <img
                                        :src="this.$icons.iconImage"
                                        alt=""
                                        class="h-5 mt-1 mx-3"
                                    />
                                </div>
                                -->
                                <div>Als Bild speichern</div>
                            </div>
                            <div class="flex-1"></div>
                        </div>
                        <div class="flex-1"></div>
                    </button>

                    <button
                        class="button-filled mx-auto flex flex-row px-3 h-10"
                        @click="triggerDownloadPdf"
                    >
                        <div class="flex-1"></div>
                        <div class="flex flex-col h-full">
                            <div class="flex-1"></div>
                            <div class="flex flex-row">
                                <!--
                                <div>
                                    <img :src="this.$icons.iconPdf" alt="" class="h-5 mt-1 mx-3" />
                                </div>
                                -->
                                <div>Als PDF speichern</div>
                            </div>
                            <div class="flex-1"></div>
                        </div>
                        <div class="flex-1"></div>
                    </button>

                    <button class="button-mobile mx-auto mt-2" @click="deletionState = 1">
                        Löschen
                    </button>
                </div>

                <div
                    v-else-if="deletionState === 1"
                    class="
                        flex flex-col
                        bg-cybo_button_container_bg
                        h-desktop_button_container
                        w-desktop_button_container
                        mt-10p
                        mx-auto
                        pt-4
                        border-2
                        rounded-t-3xl rounded-bl-3xl
                        border-cybo_button_container_border
                    "
                >
                    <div class="text-2xl">Kassenzettel löschen</div>
                    <div class="pt-4">
                        Wollen Sie Ihren Kassenzettel wirklich löschen?
                        <br />
                        Nach diesem Schritt können Sie
                        <br />
                        diesen nicht mehr abrufen.
                    </div>
                    <button
                        class="button-primary mx-auto"
                        style="height: 50px; margin-top: 40px"
                        @click="triggerDeleteBon"
                    >
                        LÖSCHEN
                    </button>
                    <button
                        class="button-mobile mx-auto"
                        style="height: 40px; margin-top: 20px"
                        @click="deletionState = 0"
                    >
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>

        <!-- BON DELETED -->
        <div v-else-if="mainState === 100" class="pt-32">
            <img :src="this.$icons.iconTrash" alt="" class="mx-auto w-12" />
            <div class="mt-10">Ihr Kassenzettel wurde erfolgreich gelöscht.</div>
        </div>

        <!-- CONNECTION ERROR -->
        <div v-else-if="mainState === -2">
            <div class="text-2xl pt-20">Verbindungsfehler</div>
            <div class="mt-10">Es konnte keine Verbindung zum Server hergestellt werden..</div>
            <button class="mt-10 button-filled">Erneut versuchen</button>
        </div>

        <!-- URL INVALID -->
        <div v-else-if="mainState === -1">
            <div class="pt-20 text-3xl">404</div>
            <div class="pt-10">Dieser Link scheint nicht zu funktionieren..</div>
        </div>

        <!-- HASHCODE INVALID -->
        <div v-else-if="mainState === 1">
            <div class="pt-20 text-3xl">404</div>
            <div class="pt-10">Es konnte kein Kassenzettel gefunden werden..</div>
        </div>

        <!-- WAITING FOR BON CREATION -->
        <div v-else-if="mainState === 0">
            <div class="pt-20">Einen Augenblick Geduld bitte..</div>
            <div
                style="border-top-color: transparent"
                class="
                    mt-10
                    mx-auto
                    w-16
                    h-16
                    border-4 border-blue-400 border-solid
                    rounded-full
                    animate-spin
                "
            ></div>
            <div class="mt-10">Ihr Kassenzettel wird in diesem Moment erzeugt..</div>
        </div>
    </div>

    <!--
        <b-row style="margin: 20px 0;">
            <b-col sm="1"></b-col>
            <b-col sm="4" style=" height: 0; margin-top: 15px; border: 1px solid #9A9A9A;"></b-col>
            <b-col sm="2">oder</b-col>
            <b-col sm="4" style=" height: 0; margin-top: 15px; border: 1px solid #9A9A9A;"></b-col>
            <b-col sm="1"></b-col>
        </b-row>

        <b-row>
            <b-col style="font-size: 14px;">
                Registrieren Sie sich jetzt kostenlos bei uns
                <br>
                & speichern Sie Ihren Kassenzettel ganz
                <br>
                bequem in Ihrem Account!
            </b-col>
        </b-row>

        <b-row style="margin-top: 15px;">
            <b-col>
                <button class="button-filled" style="background-color: #10847C; color: white;">Anmelden / Registrieren</button>
            </b-col>
        </b-row>
    -->

    <!--
        <b-container v-else>
            <b-row style="font-size: 18px; margin-top: 100px">
                <b-col> Some error occurred please reload the page! </b-col>
            </b-row>
        </b-container>
    -->
</template>

<script>
    export default {
        name: 'DesktopPageCybo',
        data() {
            return {
                deletionState: 0
            }
        },
        props: {
            pathToPng: String,
            mainState: Number
        },
        methods: {
            triggerDownloadImage: function () {
                this.$emit('triggerDownloadImage')
            },
            triggerDownloadPdf: function () {
                this.$emit('triggerDownloadPdf')
            },
            triggerDeleteBon: function () {
                this.$emit('triggerDeleteBon')
            }
        }
    }
</script>

<style scoped>
    .button-filled {
        background-color: #d4e1ee;
        border-radius: 30px;
        border: 1px solid #d4e1ee;
        color: #002e62;
        margin-bottom: 10px;
        width: 280px;
        height: 50px;
        font-size: 16px;
        font-weight: normal;
        line-height: 22px;
    }
    .button-filled:hover {
        border: 1px solid #c5ccf7;
    }

    .button-primary {
        background-color: #002e62;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 0px 1px #8d8d8d;
        border-radius: 30px;
        color: #ffffff;
        border: none;
        width: 280px;
        height: 50px;
        font-size: 16px;
        font-weight: normal;
    }

    .button-mobile {
        background-color: white !important;
        border-radius: 25px;
        /*border: 1px solid #0f4680;*/
        border: 3px solid #d4e1ee;
        width: 280px;
        height: 50px;
        color: #002e62;
        font-weight: normal;
        font-size: 16px;
    }
    .button-mobile:focus {
        outline: none;
    }

    .input-custom {
        width: 250px;
        height: 40px;
        margin-left: calc(50% - 125px);
    }
</style>